<template>
  <div class="service-wrap">
    <transition name="fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
  import navigation from './navigation.vue';
  import subNav from './subNav.vue';
  export default {
    name: 'Service',
    components: {
      navigation,
      subNav
    },
    data() {
      return {

      }
    }
  }

</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/common.scss';
</style>



// WEBPACK FOOTER //
// src/components/Service.vue